import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import { getFaculty } from "../Service/Api";
import { useEffect, useState } from "react";

const StaffDetails = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const readingData1 = await getFaculty();
        const readingData = readingData1.filter(
          (item) => item.category === "Teaching",
        );
        // Check if readingData is an array
        if (Array.isArray(readingData)) {
          // Sort the data by class as numbers
          const sortedData = readingData.sort((a, b) => {
            return parseInt(a.order) - parseInt(b.order);
          });

          setData(sortedData);
          setFilteredData(sortedData); // Initially display all sorted data
        } else {
          console.error("Error: readingData is not an array");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/staff.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Staff Details"
                breadEnd="Staff Details"
                breadMid="Staff Details"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div class="table-responsive">
                <div class="advertisementspress advertisementsyr2019">
                  <div class="table">
                    <table border="1" width="100%">
                      {filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>

                            <td>{item.qualification} </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>1</td>
                          <td>Name & Initials </td>
                          <td>Educational Qualification </td>
                        </tr>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
export default StaffDetails;
